export const ComplianceOfficerGeneralMenu = [
  {
    title: "Assigned Complaints",
    iconStyle: imagepaths.complaintsIcon,
    iconActive: imagepaths.complaintsIconActive,
    to: "/app/assignedcomplaints",
    id: ["assignedcomplaints", "assignedcomplaintsview"],
  },
]